<!--
 * @Author: 忠于自己 429022021@qq.com
 * @Date: 2025-07-12 11:14:48
 * @LastEditors: 忠于自己 429022021@qq.com
 * @LastEditTime: 2025-07-12 11:18:00
 * @FilePath: \duilvpcbase\src\views\originality\children\createQE\components\viewProductSpotCheck.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="g-container-p">
    <div class="m-container-p">
      <!-- 面包屑 -->
      <div>
        <h3>
          <slot name="title"></slot>
        </h3>
        <div class="demo-image">
          <div class="block"
               v-for="(url,index) of proCheckPicDataArr"
               :key="index">
            <el-image style="width: 200px; height: 200px"
                      :src="url"
                      :fit="'scale-down'"
                      :preview-src-list="proCheckPicDataArr"></el-image>
          </div>
        </div>
        <slot name="checkInfo"></slot>
        <div v-if="getPDFShow">
          <el-link :href="oldProCheckFile"
                   target="_blank"
                   type="primary">检测报告</el-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../../../../../html/pages/originality/createTestReport/createTestReport.scss"

import imageUpload from "../../../../../components/imageUpload/qeImageUpload"

export default {
  name: 'rawMaterialEnter',
  props: ['oldProCheckPicDataArr', 'oldProCheckFile'],
  watch: {
    oldProCheckPicDataArr (newValue) {
      this.proCheckPicDataArr = newValue;
    },
  },
  data () {
    return {
      titleText: "",
      type: "",
      proCheckPicDataArr: this.oldProCheckPicDataArr,//成品抽检原图
    }
  },
  components: {
    imageUpload
  },
  computed: {
    getPDFShow () {
      if (this.oldProCheckFile && this.oldProCheckFile.trim() !== '') {
        return true
      }
      return false
    },
  },
  methods: {
    async uploadReprot (fn) {

    },
    init () {
      this.type = this.$route.query.type
    },
    created () {
      this.init()
    },
    beforeRouteUpdate (to, from, next) {
      next();
      this.init();
      this.picDataArr = []
    },
    reload () {
      this.uploadReprot(item => {
        window.location.reload()
      })
    },
  },
}
</script>

<style scoped>


.demo-image {
  width: 60%;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: flex-start;
  align-items: flex-start;
}

.block {
  flex: 0 0 auto;
}

</style>
